export default "__VITE_PUBLIC_ASSET__4cd004e2__"